import { AppRouterProvider } from './providers/router';

function App() {
    return <AppRouterProvider />;
}

export default App;
